import { sha256 as nobleSha256 } from "@noble/hashes/sha256";
import { bytesToHex, utf8ToBytes } from "@noble/hashes/utils";
export function canonicalJson(value) {
    if (value === null)
        return "null";
    if (typeof value === "number" || typeof value === "boolean")
        return String(value);
    if (typeof value === "string")
        return JSON.stringify(value);
    if (Array.isArray(value)) {
        return "[" + value.map(canonicalJson).join(",") + "]";
    }
    if (typeof value === "object") {
        const obj = value;
        const keys = Object.keys(obj).sort();
        const entries = keys.map((k) => JSON.stringify(k) + ":" + canonicalJson(obj[k]));
        return "{" + entries.join(",") + "}";
    }
    throw new Error(`canonicalJson: unsupported value type (${typeof value})`);
}
export function sha256(input) {
    return bytesToHex(nobleSha256(utf8ToBytes(input)));
}
export function hashEvent(envelope) {
    const { hash: _ignored, ...rest } = envelope;
    return sha256(canonicalJson(rest));
}
//# sourceMappingURL=hash.js.map